<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      :title="textMap[dialogStatus]"
      :visible.sync="$store.state.work.addDialog"
      :before-close="handleClose"
    >
      <el-scrollbar style="height: 100%; padding-bottom: 8px" :vertical="true">
        <el-form
          v-show="active === 0"
          ref="form"
          status-icon
          :model="form"
          :rules="rules"
          label-width="135px"
          inline
        >
          <el-form-item :label="$t('work.taskName')" prop="taskName">
            <el-input
              v-model="form.taskName"
              :placeholder="$t('pEnter') + $t('work.taskName')"
              maxlength="50"
            />
          </el-form-item>
          <el-form-item :label="$t('work.taskType')" prop="orderType">
            <el-select
              v-model="form.orderType"
              @change="changeOrder"
              clearable
              :disabled="flag"
              style="width: 150px"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-input
              type="text"
              v-model="otherRemark"
              style="width: 100px"
              v-show="form.orderType == '5'"
              maxlength="20"
              prop="otherRemark"
            />
          </el-form-item>
          <el-form-item :label="$t('work.recipient')" prop="receiveName">
            <el-select
              v-model="form.receiveName"
              :placeholder="$t('pEnter') + $t('work.recipient')"
              clearable
            >
              <el-option
                v-for="(item, index) in userList"
                :key="index"
                :value="item.userName"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('work.accepted')" prop="checkName">
            <el-select v-model="form.checkName" clearable>
              <el-option
                v-for="(item, index) in userList"
                :key="index"
                :value="item.userName"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('device.phone')" prop="telephone">
            <el-input
              v-model="form.telephone"
              maxlength="11"
              :placeholder="
                $t('pEnter') + $t('work.recipient') + ' ' + $t('device.phone')
              "
            />
          </el-form-item>
          <el-form-item :label="$t('listQuery.deptId')" prop="deptId">
            <el-cascader
              v-model="form.deptId"
              :show-all-levels="false"
              :options="deptList"
              :props="{ checkStrictly: true, emitPath: false }"
              clearable
            />
          </el-form-item>
          <el-form-item :label="$t('work.time')" prop="startTime">
            <el-date-picker
              v-model="arrayTime"
              type="datetimerange"
              :start-placeholder="$t('startTime')"
              :end-placeholder="$t('endTime')"
              :picker-options="pickerOptions0"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['12:00:00']"
              :editable="false"
            ></el-date-picker>
          </el-form-item>

          <el-form-item :label="$t('work.remark')" prop="remark">
            <el-input
              v-model="form.remark"
              type="textarea"
              :placeholder="$t('pEnter') + $t('work.remark')"
              maxlength="100"
            />
          </el-form-item>
        </el-form>

        <el-form v-show="active === 1" label-width="125px" inline>
          <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
            v-if="form.orderType == 4 && !flag"
          >
            <el-tab-pane
              :label="item.label"
              v-for="item in deviceCategoryList"
              :name="item.value"
              :key="item.value"
            >
            </el-tab-pane>
          </el-tabs>
          <el-transfer
            filterable
            ref="transfers"
            :filter-placeholder="$t('pEnter') + $t('device.deviceName')"
            :titles="[$t('table.optional'), $t('table.selected')]"
            v-model="seletedList"
            :data="deviceList"
            style="width: 800px; margin: 0px auto"
            target-order="unshift"
            @change="changeNmae"
          />
        </el-form>
      </el-scrollbar>
      <span v-show="active === 0" slot="footer" class="dialog-footer">
        <span class="btn-item long" @click="next"> {{ $t('work.next') }} </span>
      </span>
      <span v-show="active === 1" slot="footer" class="dialog-footer">
        <span class="btn-item long" @click="active = 0"
          >{{ $t('work.previous') }}
        </span>
        <span class="btn-item" @click="closed">{{ $t('btn.cancel') }}</span>
        <span
          class="btn-item"
          @click="dialogStatus == 'create' ? createData() : updateData()"
          >{{ $t('btn.save') }}</span
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserList } from '@/api/user'
import { getAlarmList } from '@/api/alarm'
import { getDeptSubByDeptId } from '@/api/department'
import { insertOrderTask, updateOrderTask, getDeviceList } from '@/api/work'
export default {
  props: ['dialogStatus', 'otherRemarkParent', 'arrayTimeParent', 'flag'],
  data() {
    var validateOrderType = (rule, value, callback) => {
      if (value == '5' && this.otherRemark == '') {
        callback(new Error(this.$t('pEnter') + this.$t('work.time')))
      } else if (value == '' || value == null) {
        callback(new Error(this.$t('pEnter') + this.$t('work.taskType')))
      } else {
        callback()
      }
    }
    var validateTime = (rule, value, callback) => {
      if (this.arrayTime.length <= 0) {
        callback(new Error(this.$t('pEnter') + this.$t('work.time')))
      } else {
        callback()
      }
    }
    return {
      textMap: {
        update: this.$t('table.update'),
        create: this.$t('table.create')
      },
      createStatus: false,
      active: 0,
      arrayTime: [],
      options: [
        {
          value: '1',
          label: this.$t('work.install')
        },
        {
          value: '3',
          label: this.$t('work.dismantle')
        },
        {
          value: '4',
          label: this.$t('work.faults')
        },
        {
          value: '5',
          label: this.$t('work.other')
        }
      ],
      userList: [],
      deptList: [],
      otherRemark: '',
      rules: {
        telephone: [
          {
            required: true,
            message: this.$t('pEnter') + this.$t('device.phone'),
            trigger: 'blur'
          }
        ],
        taskName: [
          {
            required: true,
            message: this.$t('pEnter') + this.$t('work.taskName'),
            trigger: 'blur'
          }
        ],
        orderType: [
          { required: true, validator: validateOrderType, trigger: 'change' }
        ],
        startTime: [
          { required: true, validator: validateTime, trigger: 'change' }
        ],
        checkName: [
          {
            required: true,
            message: this.$t('pEnter') + this.$t('work.accepted'),
            trigger: 'change'
          }
        ],
        receiveName: [
          {
            required: true,
            message: this.$t('pEnter') + this.$t('work.recipient'),
            trigger: 'change'
          }
        ],
        deptId: [
          {
            required: true,
            message: this.$t('pEnter') + this.$t('listQuery.deptId'),
            trigger: 'change'
          }
        ]
      },
      pickerOptions0: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      deviceCategory: null,
      deviceCategoryList: [
        {
          value: 'normal',
          label: this.$t('work.normal')
        },
        {
          value: 'fault',
          label: this.$t('work.fault')
        }
      ],
      seletedList: [],
      deviceList: [],
      alarmList: [],
      activeName: 'fault'
    }
  },
  computed: {
    form: {
      get() {
        return this.$store.state.work.form
      },
      set(val) {
        this.$store.state.work.form = val
      }
    },
    addDialog: {
      get() {
        return this.$store.state.work.addDialog
      },
      set(val) {
        this.$store.state.work.addDialog = val
      }
    }
  },
  watch: {
    arrayTime(val) {
      if (val) {
        this.form.startTime = val && val[0]
        this.form.deadline = val && val[1]
      }
    },
    addDialog(val) {
      this.$store.state.work.selectDevice = []
      if (val === false) {
        this.$store.state.work.form.deviceList = []
        if (this.dialogStatus == 'create') {
          this.$store.state.work.form = {}
        }
      }
      if (val == true) {
        this.active = 0
        if (this.dialogStatus == 'update') {
          this.otherRemark = this.otherRemarkParent
          this.arrayTime = this.arrayTimeParent
        }
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
      }
    }
  },
  mounted() {
    this.getUser()
    this.getDeptInfo()
  },

  methods: {
    changeOrder() {
      this.form = Object.assign({}, this.form)
    },
    //获取用户
    getUser() {
      getUserList().then((res) => {
        this.userList = res.data.list
      })
    },
    next() {
      //填选了必填项才能进入下一步
      let deviceList = []
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.active++ > 2) {
            this.active = 0
          }
          this.seletedList = []
          this.deviceList = this.$store.state.work.deviceAllList.map((e) => {
            this.seletedList.push(e.alarmId ? e.alarmId - 0 : e.deviceCode)
            return {
              label: e.deviceName,
              key: e.alarmId ? e.alarmId - 0 : e.deviceCode,
              alarmId: e.alarmId,
              deviceCode: e.deviceCode,
              deviceId: e.deviceId,
              deviceType: e.deviceType,
              deviceName: e.deviceName,
              latitude: e.latitude,
              longitude: e.longitude,
              areaId: e.areaId,
              disabled: this.flag ? true : false
            }
          })
          if (this.flag) {
            return
          }
          if (this.form.orderType == 4) {
            this.activeName = 'fault'
            getAlarmList({ alarmStatus: 1 }).then((e) => {
              this.alarmList = e.data.list
              deviceList = e.data.list.map((e) => {
                return {
                  label: e.deviceName,
                  key: e.alarmId,
                  deviceCode: e.deviceCode,
                  deviceType: e.typeCode,
                  deviceName: e.deviceName,
                  alarmId: e.alarmId
                }
              })
              deviceList = deviceList.filter((e) => {
                return !this.seletedList.includes(e.key)
              })
              this.deviceList = [...deviceList, ...this.deviceList]
            })
          } else {
            getDeviceList().then((e) => {
              deviceList = e.data.list.map((e) => {
                return {
                  label: e.deviceName,
                  key: e.deviceCode,
                  deviceId: e.deviceId,
                  deviceType: e.deviceType,
                  deviceName: e.deviceName,
                  latitude: e.latitude,
                  longitude: e.longitude,
                  areaId: e.deptId
                }
              })
              deviceList = deviceList.filter((e) => {
                return !this.seletedList.includes(e.key)
              })
              this.deviceList = [...deviceList, ...this.deviceList]
            })
          }
        }
      })
    },
    changeNmae(val) {
      console.log(val)
    },
    handleClick(tab) {
      console.log(tab)
      if (this.activeName == 'fault') {
        let deviceList = []
        if (this.seletedList.length > 0) {
          deviceList = this.deviceList.filter((e) => {
            return this.seletedList.includes(e.key)
          })
        }
        this.deviceList = this.alarmList.map((e) => {
          return {
            label: e.deviceName,
            key: e.alarmId,
            deviceCode: e.deviceCode,
            deviceType: e.typeName,
            deviceName: e.deviceName,
            alarmId: e.alarmId
          }
        })
        this.deviceList = [...this.deviceList, ...deviceList]
      } else {
        this.getDeviceList()
      }
    },
    getDeviceList() {
      let deviceList = []
      if (this.seletedList.length > 0) {
        this.deviceList = this.deviceList.filter((e) => {
          return this.seletedList.includes(e.key)
        })
      }
      getDeviceList().then((e) => {
        deviceList = e.data.list.map((e) => {
          return {
            label: e.deviceName,
            key: e.deviceCode,
            deviceId: e.deviceId,
            deviceType: e.deviceType,
            deviceName: e.deviceName,
            latitude: e.latitude,
            longitude: e.longitude
          }
        })

        deviceList = deviceList.filter((e) => {
          return !this.seletedList.includes(e.key)
        })
        this.deviceList = [...this.deviceList, ...deviceList]
      })
    },
    closed() {
      this.addDialog = false
      this.$refs['form'].resetFields()
      this.active = 0
    },
    async createData() {
      if (this.createStatus) {
        return
      }
      await this.getSelectedList()
      if (this.form.deviceList.length > 0) {
        this.createStatus = true
        insertOrderTask(this.form)
          .then((res) => {
            this.addDialog = false
            this.createStatus = false
            this.$store.state.alarm.workDialog = false
            if (res.status === 200) {
              this.$notify({
                title: this.$t('title.success'),
                message: this.$t('title.addSuccess'),
                type: 'success',
                duration: 3000
              })

              this.$parent.getList && this.$parent.getList()
              this.$parent.workList && this.$parent.workList()
              this.arrayTime = []
            }
          })
          .catch(() => {
            this.createStatus = false
          })
      }
    },
    async getSelectedList() {
      let deviceList = []
      deviceList = this.deviceList.filter((e) => {
        console.log(this.seletedList.includes(e.key))
        return this.seletedList.includes(e.key)
      })
      console.log(deviceList, this.deviceList, deviceList.length)
      for (let i = 0; i < deviceList.length; i++) {
        console.log(deviceList[i].alarmId, '----1')
        if (deviceList[i].alarmId) {
          console.log(deviceList[i].alarmId)
          await getDeviceList({
            deviceCode: deviceList[i].deviceCode
          }).then((res) => {
            res.data.list.forEach((e) => {
              if (deviceList[i].deviceCode == e.deviceCode) {
                deviceList[i].deviceId = e.deviceId
                deviceList[i].deviceType = e.deviceType
                deviceList[i].deviceName = e.deviceName
                deviceList[i].latitude = e.latitude
                deviceList[i].longitude = e.longitude
                deviceList[i].areaId = e.deptId
              }
            })
            console.log('-----------1------')
          })
        }
      }
      this.form.deviceList = deviceList.map((e) => {
        return e
      })
      console.log(this.form.deviceList)
    },
    addTask() {
      this.$store.state.work.isDialog = true
      this.form.orderType !== '1' && this.form.orderType !== '3'
        ? (this.$store.state.work.changeName = 'alarm')
        : (this.$store.state.work.changeName = 'noAlarm')
    },
    async updateData() {
      await this.getSelectedList()
      if (this.form.deviceList.length > 0) {
        updateOrderTask(this.form).then((res) => {
          if (res.status === 200) {
            this.addDialog = false
            this.$store.state.alarm.workDialog = false
            this.$notify({
              title: this.$t('title.success'),
              message: this.$t('title.updateSuccess'),
              type: 'success',
              duration: 3000
            })
            this.$parent.getList && this.$parent.getList()
            this.$parent.workList && this.$parent.workList()
            this.arrayTime = []
          }
        })
      }
    },

    // 数组遍历
    getdeptIdList(data) {
      if (!data.length) {
        data = [data]
      }
      const list = data.map((res) => {
        const obj = {}
        if (res.subBeanList) {
          obj.children = this.getdeptIdList(res.subBeanList)
          obj.label = res.nodeBean.deptName
          obj.value = res.nodeBean.deptId
          return obj
        } else {
          obj.label = res.nodeBean.deptName
          obj.value = res.nodeBean.deptId
          return obj
        }
      })
      return list
    },
    getDeptInfo() {
      // 获取机构列表
      getDeptSubByDeptId().then((res) => {
        if (res.data) {
          this.deptList = this.getdeptIdList(res.data)
        }
      })
    },
    handleClose(done) {
      this.$confirm(this.$t('work.Confirm'))
        .then(() => {
          done()
          if (this.active === 0) {
            this.$refs['form'].clearValidate()
          }
          this.active = 0
          this.arrayTime = []
          this.$store.state.work.type = ''
          this.$refs['form'].resetFields()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.changeEqControl {
  text-align: right;
  margin-bottom: 13px;
}
</style>
